import { render, staticRenderFns } from "./SkupSuorganizatori.vue?vue&type=template&id=48fcef81&scoped=true&"
import script from "./SkupSuorganizatori.vue?vue&type=script&lang=js&"
export * from "./SkupSuorganizatori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fcef81",
  null
  
)

export default component.exports